import { useCallback } from 'react';
import { useRouter } from '@/hooks';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { GenerateReport } from '../GenerateReport';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useGetAssemblies } from '../hooks/useGetAssemblies';
import { LocationTag, VIEW_IN_3D_LABEL, VIEW_IN_3D_TOOLTIP_LABEL } from '@/constants';
import { AssemblyNavigation } from '../AssemblyNavigation';
import { useGetDefectPill } from '../hooks/useGetDefectPill';
import { ReviewHeaderShell } from '../ReviewHeaderShell';
import { AssemblyNavigationStyle } from './styles';

type ReviewScreenHeaderProps = {
  handleClose: () => void;
};

export const ReviewScreenHeader = ({ handleClose }: ReviewScreenHeaderProps) => {
  const structureId = useGetStructureId();
  const router = useRouter();
  const defectPill = useGetDefectPill();
  const selectedAssemblyName = useAtomValue(state.selectedAssemblyName);

  useGetAssemblies();

  const handleViewIn3D = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const url = `/analysis/${structureId}/viewer?assembly=${selectedAssemblyName}`;
      const isCtrlClick = event.ctrlKey || event.metaKey;
      isCtrlClick ? window.open(url, '_blank') : router.push(url);
    },
    [router, structureId, selectedAssemblyName]
  );

  return (
    <ReviewHeaderShell
      onClose={handleClose}
      leftContent={
        <Stack direction="row" gap="1.6rem" alignItems="center">
          <AssemblyNavigation sx={AssemblyNavigationStyle} location={LocationTag.ReviewPanel}>
            {defectPill}
          </AssemblyNavigation>
        </Stack>
      }
      actions={
        <>
          <Tooltip title={VIEW_IN_3D_TOOLTIP_LABEL} placement="bottom" arrow>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AbyssIcon iconName="cube-secondary" size="md" />}
              onClick={handleViewIn3D}
              id="review-panel-view-in-3d-button"
            >
              {VIEW_IN_3D_LABEL}
            </Button>
          </Tooltip>
          <GenerateReport useSelectedComponent location={LocationTag.ReviewPanel} />
        </>
      }
    />
  );
};
